import './style.css';
import { ReactComponent as BackIcon } from "../../../../assets/svg/icons/back.svg";
import { useFilter } from '../../../../hooks/useFilter';
import { ShowData } from '..';
import { useEffect } from "react";
import { useEditOnboarding } from "../../../../hooks/useEditOnboarding";
import { IOptionsSystemManagerLinks } from '../../../../contexts/FilterContext';
import { useTranslation } from 'react-i18next';

const systemManagerSections: {
    titleKey: string;
    items: { labelKey: string; value: NonNullable<IOptionsSystemManagerLinks> }[];
}[] = [
        {
            titleKey: "registrations",
            items: [
                { labelKey: "propertiesAreas", value: "PROPERTIES_AREAS" },
                { labelKey: "profiles", value: "PROFILES_USERS" }
            ],
        },
        {
            titleKey: "monitoring",
            items: [
                { labelKey: "taskMonitoring", value: "TASK_EVALUATION" },
                { labelKey: "pastureEvaluation", value: "PASTURE_EVALUATION" },
            ],
        },
        {
            titleKey: "animals",
            items: [
                { labelKey: "batches", value: "CREATE_BATCH" },
                { labelKey: "pastureManagement", value: "PASTURE_MANAGEMENT" },
                { labelKey: "categoriesWeights", value: "CATTLE_MAP" },
            ],
        },
        {
            titleKey: "supplementation",
            items: [
                { labelKey: "salters", value: "SALTERS" },
                { labelKey: "products", value: "PRODUCTS" },
                { labelKey: "stock", value: "STOCK" },
            ],
        },
    ];

export function SystemManager() {
    const { t } = useTranslation();
    const { systemManager, sideBarOptionSelected, setSystemManager, setRangeDays, setViewRangeDays, onBoardingDate } = useFilter();
    const { optionForm, setOptionForm } = useEditOnboarding();

    useEffect(() => {
        const lastMounth = new Date();
        lastMounth.setMonth(lastMounth.getMonth() - 1);
        const newRangeDays = { from: lastMounth, to: new Date() }
        setRangeDays(newRangeDays);
        setViewRangeDays(newRangeDays);
    }, []);

    useEffect(() => {
        if (systemManager !== "TASK_EVALUATION") return;

        const today = new Date();
        const thirtyDaysAgo = new Date(today);
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        const defaultRange = { from: thirtyDaysAgo, to: today };

        setRangeDays(defaultRange);
        setViewRangeDays(defaultRange);
    }, [setRangeDays, setViewRangeDays, systemManager]);

    useEffect(() => {
        if (
            systemManager !== "PASTURE_EVALUATION" ||
            !onBoardingDate ||
            Number.isNaN(onBoardingDate.getTime())
        ) {
            return;
        }

        const defaultRange = {
            from: new Date(onBoardingDate),
            to: new Date(),
        };

        setRangeDays(defaultRange);
        setViewRangeDays(defaultRange);
    }, [onBoardingDate, setRangeDays, setViewRangeDays, systemManager]);

    useEffect(() => {
        const openingEvaluatorForm =
            systemManager === "MANAGER_EVALUATORS" &&
            optionForm === "create-evaluator";
        if (!openingEvaluatorForm) setOptionForm(undefined)
    }, [setOptionForm, systemManager]);

    return (
        sideBarOptionSelected == "MANAGER_SYSTEM" && systemManager === null
            ?
            <div className="templateDataManager">
                <h2 style={{ marginBottom: 10 }}>{t("systemManager.title")}</h2>
                <div className="delimiter" style={{ marginBottom: 20 }} />
                <div className="templateDataManager__container">
                    {systemManagerSections.map((section) => (
                        <div className="templateDataManager__container--item" key={section.titleKey}>
                            <h2>{t(`systemManager.${section.titleKey}`)}</h2>
                            {section.items.map((item) => (
                                <button
                                    className="templateDataManager__container--container"
                                    key={item.value}
                                    onClick={() => setSystemManager(item.value)}
                                >
                                    <span>{t(`systemManager.${item.labelKey}`)}</span>
                                    <BackIcon className='icon' />
                                </button>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
            :
            <ShowData />
    );
};
